import React, { Fragment } from 'react'
import { BulkDeleteButton, Datagrid, DeleteButton, List, TextField, translate } from 'react-admin'
import { AssetStatusListActions } from './AssetStatusListActions'

const PostBulkActionButtons = (props) => (
  <Fragment>
    <BulkDeleteButton disabled={!props.permissions?.includes('delete:assets')} {...props} />
  </Fragment>
)

const AssetStatusList = ({ accessible, dispatch, permissions, ...props }) => {
  return (
    <List
      bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      actions={<AssetStatusListActions />}
      {...props}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        {permissions?.includes('delete:assets') && <DeleteButton />}
      </Datagrid>
    </List>
  )
}

export default translate(AssetStatusList)
